{
  "version": "1.2.6",
  "objects": {
    "7430094755548238083": {
      "type": "frame",
      "id": "7430094755548238083",
      "z": 7274,
      "textContent": "",
      "left": -1058.9060742361248,
      "top": 2313.058567222324,
      "width": 400,
      "height": 500,
      "scaleX": 0.7694665816350448,
      "scaleY": 0.09858628735634853,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "Zz",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 10,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7430094755543299228": {
      "type": "shape",
      "id": "7430094755543299228",
      "z": 7275,
      "shapeName": "icon",
      "textContent": "",
      "left": -774.3817377493194,
      "top": 2329.9953021276415,
      "width": 100,
      "height": 160,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.10262296167212569,
      "scaleY": 0.10262296167212569,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#BDBDBD",
      "angle": 0,
      "container": "7430094755548238083",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "iconName": "fas/xmark",
      "locked": false
    },
    "7430094755543848791": {
      "type": "wireframe",
      "id": "7430094755543848791",
      "z": 7276,
      "top": 2323.558567222324,
      "left": -1048.9060742361248,
      "width": 52,
      "height": 52,
      "scaleX": 0.5633296861187359,
      "scaleY": 0.5633296861187359,
      "container": "7430094755548238083",
      "layoutPosition": "Zzzzzx",
      "wireframeName": "avatar",
      "fill": "#F9C61F",
      "textColor": "#333333",
      "style": "square",
      "fontSize": 14,
      "label": { "value": "Label", "position": "noLabel" },
      "placeholder": {
        "value": "",
        "iconLeft": { "prefix": "fas", "iconName": "circle-exclamation" },
        "iconRight": null
      },
      "showBackground": true,
      "showOutline": true
    },
    "7430094755548716404": {
      "type": "frame",
      "id": "7430094755548716404",
      "z": 7277,
      "textContent": "Frame 96",
      "left": -1009.6129305579506,
      "top": 2325.7051390614115,
      "width": 400,
      "height": 500,
      "scaleX": 0.5630779820215777,
      "scaleY": 0.05,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": "7430094755548238083",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7430094755540728286": {
      "type": "shape",
      "id": "7430094755540728286",
      "z": 7278,
      "shapeName": "text",
      "textContent": "<p>Warning banner description</p>",
      "left": -1009.6129305579506,
      "top": 2325.7051390614115,
      "width": 180.83333333333334,
      "height": 29.166666666666668,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8571428571428571,
      "scaleY": 0.8571428571428571,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 12,
      "angle": 0,
      "container": "7430094755548716404",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "maskType": "none",
      "locked": false,
      "reactions": {}
    }
  }
}
